import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/plantillafactura',
    beforeEnter() { location.href = 'https://plantillafactura.es' }
  },
  {
    path: '/consejos',
    beforeEnter() { location.href = 'https://plantillafactura.es/consejos/' }
  },
  {
    path: '/plantillas',
    beforeEnter() { location.href = 'https://plantillafactura.es/plantillas/' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
